import { size, mediaQueries } from '@everlywell/leaves';
import { animated } from 'react-spring';
import styled from 'styled-components';

// TODO: negative margin for showing top of content on each page change
export const ModalInner = styled.div`
  margin-top: -${size.xl2}px;
  padding-top: ${size.xl2}px;
  padding-bottom: ${size.xl6}px;
  height: inherit;

  ${mediaQueries.forTabletHorizontalUp} {
    height: calc(100vh - ${size.xl2}px * 4);
  }
`;

export const AnimatedContentWrapper = styled(animated.div)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
